import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { get, isEmpty, join } from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import {
  AutoComplete,
  DateField,
  DropdownWrapper,
  GridContainer,
  GridItem,
  SwitchWrapper,
  TextFieldWrapper,
} from '../../common';
import {
  CUSTOM_NAME,
  DATE_PRESCRIBED,
  IS_SEARCH_RESULT,
  MEDICATION_NAME,
  MEDICATION_TYPES,
  MEDICATION_NOTES,
  PHARMACY_ID,
  PRESCRIBING_DOCTOR_ID,
  TYPE,
  ALTERNATE_NAME,
} from '../constants';
import LiquidForm from './LiquidForm';
import IVForm from './IVForm';
import NebulizerForm from './NebulizerForm';
import PillForm from './PillForm';

function renderTypeForm(type, props) {
  if (type === MEDICATION_TYPES.LIQUID) {
    return <LiquidForm {...props} />;
  }
  if (type === MEDICATION_TYPES.IV) {
    return <IVForm {...props} />;
  }
  if (type === MEDICATION_TYPES.NEBULIZER) {
    return <NebulizerForm {...props} />;
  }
  if (type === MEDICATION_TYPES.PILL) {
    return <PillForm {...props} />;
  }
  return null;
}

class Medication extends React.Component {
  state = {
    selectedType: get(this.props, ['values', ...this.props.paths, TYPE], ''),
  };

  handleTypeChange = e => {
    this.setState({
      selectedType: e.target.value,
    });
  };

  render() {
    const {
      doctors,
      onSearch,
      paths,
      pharmacies,
      setFieldValue,
      values,
    } = this.props;
    const { selectedType } = this.state;
    const isSearchResult = get(values, [...paths, IS_SEARCH_RESULT]);
    const fdaMedication = get(values, [...paths, MEDICATION_NAME]);

    return (
      <GridContainer>
        <GridItem xs={12}>
          <Field
            component={SwitchWrapper}
            id={IS_SEARCH_RESULT}
            label="Search Medications"
            name={join([...paths, IS_SEARCH_RESULT], '.')}
          />
        </GridItem>
        <GridItem xs={12}>
          {!isSearchResult ? (
            <Field
              component={TextFieldWrapper}
              id={CUSTOM_NAME}
              label="Custom Medication Name"
              name={join([...paths, CUSTOM_NAME], '.')}
              paths={[...paths, CUSTOM_NAME]}
              required
            />
          ) : (
            <Field
              component={AutoComplete}
              defaultSelectedItem={fdaMedication}
              getSuggestions={onSearch}
              id={MEDICATION_NAME}
              label="Medication Name"
              name={join([...paths, MEDICATION_NAME], '.')}
              paths={[...paths, MEDICATION_NAME]}
              required
            />
          )}
        </GridItem>
        <GridItem xs={12}>
          <Field
            component={TextFieldWrapper}
            id={ALTERNATE_NAME}
            label="Alternate Medication Name"
            name={join([...paths, ALTERNATE_NAME], '.')}
            paths={[...paths, ALTERNATE_NAME]}
          />
        </GridItem>
        <GridItem xs={12}>
          <Field
            component={DropdownWrapper}
            id={TYPE}
            label="Type of Medication"
            name={join([...paths, TYPE], '.')}
            onChange={this.handleTypeChange}
            paths={[...paths, TYPE]}
          >
            <MenuItem value={MEDICATION_TYPES.LIQUID}>Liquid</MenuItem>
            <MenuItem value={MEDICATION_TYPES.PILL}>Pill or Tablet</MenuItem>
            <MenuItem value={MEDICATION_TYPES.IV}>IV</MenuItem>
            <MenuItem value={MEDICATION_TYPES.NEBULIZER}>Nebulizer</MenuItem>
            <MenuItem value={MEDICATION_TYPES.OTHER}>Other</MenuItem>
          </Field>
        </GridItem>
        {renderTypeForm(selectedType, {
          paths,
        })}
        <GridItem sm={6} xs={12}>
          <Field
            component={DropdownWrapper}
            id={PHARMACY_ID}
            label="Pharmacy"
            name={join([...paths, PHARMACY_ID], '.')}
            paths={[...paths, PHARMACY_ID]}
          >
            {isEmpty(pharmacies) ? (
              <MenuItem value={undefined}>
                You don't have any saved pharmacies.
              </MenuItem>
            ) : (
              pharmacies.map(pharmacy => (
                <MenuItem
                  key={pharmacy.id || pharmacy.tempId}
                  value={pharmacy.id || pharmacy.tempId}
                >
                  {pharmacy.pharmacyName}
                </MenuItem>
              ))
            )}
          </Field>
        </GridItem>
        <GridItem sm={6} xs={12}>
          <Field
            component={DropdownWrapper}
            id={PRESCRIBING_DOCTOR_ID}
            label="Prescribing Doctor"
            name={join([...paths, PRESCRIBING_DOCTOR_ID], '.')}
            paths={[...paths, PRESCRIBING_DOCTOR_ID]}
          >
            {isEmpty(doctors) ? (
              <MenuItem value={undefined}>
                You don't have any saved doctors.
              </MenuItem>
            ) : (
              doctors.map(doctor => (
                <MenuItem
                  key={doctor.id || doctor.tempId}
                  value={doctor.id || doctor.tempId}
                >
                  {doctor.firstName} {doctor.lastName}
                </MenuItem>
              ))
            )}
          </Field>
        </GridItem>
        <GridItem lg={4} xs={12}>
          <DateField
            fieldName={DATE_PRESCRIBED}
            label="Date Prescribed"
            paths={paths}
            setFieldValue={setFieldValue}
            values={values}
          />
        </GridItem>
        <GridItem lg={12} xs={12}>
          <Field
            component={TextFieldWrapper}
            id={MEDICATION_NOTES}
            label="Notes"
            multiline
            name={join([...paths, MEDICATION_NOTES], '.')}
            paths={[...paths, MEDICATION_NOTES]}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

Medication.propTypes = {
  onSearch: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  doctors: PropTypes.array,
  paths: PropTypes.array,
  pharmacies: PropTypes.array,
  values: PropTypes.object,
};

Medication.defaultProps = {
  doctors: [],
  paths: [],
  pharmacies: [],
  values: {},
};

export default Medication;



// WEBPACK FOOTER //
// ./src/modules/MedicationPage/components/Medication.js